module.exports = __webpack_public_path__ + "static/assets/adeddf744fb7f0504974fd545b5500e4.svg";